var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1776_255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 34.167C21.8335 31.8333 24.66 28.7276 31.6648 28.4986C32.1248 28.4836 32.5 28.121 32.5 27.6608C32.5 23.8443 32.5 11.3078 32.5 7.49133C32.5 7.03109 32.1248 6.66578 31.6647 6.67701C24.6598 6.84826 21.8335 9.18186 20 11.5155C18.1665 9.18186 15.3401 6.84826 8.33532 6.67701C7.87522 6.66578 7.5 7.03949 7.5 7.49973C7.5 10.9139 7.5 23.8393 7.5 27.662C7.5 28.1221 7.87525 28.4836 8.33523 28.4986C15.3401 28.7276 18.1665 31.8333 20 34.167ZM20 11.5155V34.167",
    stroke: "#A0551C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0588 10H35.8333C36.2934 10 36.6666 10.3731 36.6666 10.8333V32.565C36.6666 33.2393 35.8721 33.6873 35.2558 33.4135C33.9306 32.8247 31.7191 32.1053 28.8234 32.1053C23.9214 32.1053 19.9999 35 19.9999 35C19.9999 35 16.0784 32.1053 11.1764 32.1053C8.28067 32.1053 6.06919 32.8247 4.74404 33.4135C4.12772 33.6873 3.33325 33.2393 3.33325 32.565V10.8333C3.33325 10.3731 3.70635 10 4.16659 10H7.9411",
    stroke: "#A0551C",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1776_255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpenIcon);
export default __webpack_public_path__ + "static/media/bookOpenIcon.5ca374749da2dcd2ccda8a305ddbc038.svg";
export { ForwardRef as ReactComponent };